module.exports = __webpack_public_path__ + "static/img/5.f6a5620.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/4/1/sp/5.png
// module id = ZRtV
// module chunks = 0